import clsx from "clsx";
import { Text } from "./base";
import { EvaluationStatus } from "../redux/reducers/evaluationSlices";

type EvaluationStatusPillProps = {
  status: EvaluationStatus;
};

export const EvaluationStatusPill = ({ status }: EvaluationStatusPillProps) => {
  return (
    <Text
      className={clsx(
        "w-auto px-2 py-0.5 rounded-full text-xs",
        status === "complete" && "bg-success/10 dark:bg-success/20 text-success-dark dark:text-success-light",
        status === "pending" && "bg-yellow-100 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-300",
        status === "error" && "bg-error/10 dark:bg-error/20 text-error-dark dark:text-error-light",
      )}
    >
      {status === "complete" ? "Completed" : status === "pending" ? "Pending" : "Error"}
    </Text>
  );
};
